(function () {
    'use strict';

    angular
        .module('core.services')
        .service('ClusterPerformanceService', ClusterPerformanceService)

    /** @ngInject */
    function ClusterPerformanceService(HttpService) {
        const ClusterPerformanceService = {
            get: get,
            getAll: getAll,
            getByParameters: getByParameters,
            post: post,
            put: put,
            deleteClusterPerformance: deleteClusterPerformance
        }

        return ClusterPerformanceService;

        function get(clusterPerformanceId) {
            return HttpService.get(`/clusters-performance/${clusterPerformanceId}`);
        }

        function getAll() {
            return HttpService.get('/clusters-performance/all');
        }

        function getByParameters(params) {
            return HttpService.get('/clusters-performance', {
                params
            });
        }

        function post(clusterPerformanceData) {
            return HttpService.post('/clusters-performance', clusterPerformanceData);
        }

        function put(clusterPerformanceData) {
            return HttpService.put('/clusters-performance', clusterPerformanceData);
        }

        function deleteClusterPerformance(clusterPerformanceId) {
            return HttpService.delete(`/clusters-performance/${clusterPerformanceId}`);
        }
    }
}());